import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import MasterLedgerAddForm from "./MasterLedgerAddForm";

const MasterLedgerAdd = ({ buttonConfig, tableData , isButtonClicked}) => {
  const schema = z.object({
    account_name: z.string().nonempty(),
    account_short_name: z.string().nonempty(),
    group_name: z.string().nonempty(),
    account_type: z.string().nonempty(),

    credit_debit: z.string(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterLedgerAddForm
      form={form}
      tableData={tableData}
      segmentName={buttonConfig.name}
      addHandler={buttonConfig.addHandler}
      closeHandler={buttonConfig.closeAddModal}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterLedgerAdd;
